import { getIsFeatureEnabledForCurrentUser } from '../element/feature/elementFeatureSelector';
import { ExperimentId } from '../../common/experiments/experimentsConstants';

/**
 * Whether UX sounds should play for the current user.
 * Currently gated purely on the feature flag; a user preference (mute) can be folded in here later.
 */
export const getIsSoundsEnabledForCurrentUser = getIsFeatureEnabledForCurrentUser(ExperimentId.uxSounds);
